import actionCreatorFactory from 'typescript-fsa';
import { DataLayer } from '@shared/types/data-layer';
import { TrackingImpression } from '@shared/types/tracking';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const saveTrackingData = actionCreator<DataLayer>('SAVE_TRACKING_DATA');
export const saveImpressionData = actionCreator<TrackingImpression>('SAVE_IMPRESSION_DATA');
export const clearImpressionData = actionCreator('CLEAR_IMPRESSION_DATA');
